import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { DataGridLink } from '@carcareers/components';
import { routes } from '@carcareers/utils';

export const PROMO_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'idLink',
    headerName: 'View',
    width: 90,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.ADMIN_HOME}/${routes.ADMIN_PROMOS_VIEW.replace(':id', params.row.id.toString())}`}
        content={params.row.id}
      />
    ),
  },
  {
    field: 'code',
    headerName: 'Code',
    width: 150,
    renderCell: (params) => {
      return (
        <DataGridLink
          link={`/${routes.ADMIN_HOME}/${routes.ADMIN_PROMOS_VIEW.replace(':id', params.row.id.toString())}`}
          content={params.value}
        />
      );
    },
  },
  {
    field: 'discount',
    headerName: 'Discount',
    width: 150,
    valueGetter: (_, row) => (row.type === 'percentage' ? `${row.discount}%` : `$${row.discount}`),
  },
  {
    field: 'type',
    headerName: 'Type',
    width: 150,
    valueGetter: (_, row) => `${row.type.charAt(0).toUpperCase() + row.type.slice(1)}`,
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    width: 150,
    valueGetter: (_, row) =>
      row.startDate
        ? row.startDate.toLocaleString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
          })
        : 'N/A',
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    width: 150,
    valueGetter: (_, row) =>
      row.endDate
        ? row.endDate.toLocaleString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
          })
        : 'N/A',
  },
  {
    field: 'maxUses',
    headerName: 'Max Uses',
    width: 150,
  },
  {
    field: 'uses',
    headerName: 'Current Uses',
    width: 160,
  },
  {
    field: 'isActive',
    headerName: 'Status',
    width: 150,
    valueGetter: (_, row) => (row.isActive ? 'active' : 'inactive'),
    renderCell: (params) => {
      const status = params.value;
      let backgroundColor;
      let color;

      switch (status) {
        case 'active':
          backgroundColor = 'success.light';
          color = 'success.contrastText';
          break;
        case 'inactive':
          backgroundColor = 'error.light';
          color = 'error.contrastText';
          break;
        default:
          backgroundColor = 'secondary.light';
          color = 'text.primary';
      }

      return <Chip label={status.charAt(0).toUpperCase() + status.slice(1)} sx={{ backgroundColor, color }} />;
    },
  },
];

export const PROMO_INDEX_COLUMN_INITIAL_STATE: Record<string, boolean> = {
  id: true,
  code: true,
  discount: true,
  type: true,
  startDate: true,
  endDate: true,
  maxUses: true,
  uses: true,
  isActive: true,
};
